module.exports = __webpack_public_path__ + "fonts/almoni-black-aaa.53f24db.woff";